import { render } from "./ReViews.vue?vue&type=template&id=9b001156"
import script from "./ReViews.vue?vue&type=script&lang=js"
export * from "./ReViews.vue?vue&type=script&lang=js"
script.render = render

export default script